import { IMPORT_RUNS } from '@src/graphql/queries/importRun';
// eslint-disable-next-line import/no-extraneous-dependencies
import { usePaginatedFetchItems } from 'pe-core-frontend';
export const useImportRuns = ({ clientId, status, startDate, endDate }) => {
    const { page, setPage, pageSize, setPageSize, orderBy, setOrderBy, orderByDir, setOrderByDir, total, items: importRuns, loading, error, find, refetch, } = usePaginatedFetchItems({
        spec: {
            clientId,
            status: status || undefined,
            startDate: startDate || undefined,
            endDate: endDate || undefined,
        },
        fetchQuery: IMPORT_RUNS,
        dataProp: 'importRuns',
        initialPageSize: 10,
    });
    return {
        importRuns,
        loading,
        page,
        pageSize,
        setPage,
        setPageSize,
        orderBy,
        setOrderBy,
        orderByDir,
        setOrderByDir,
        error,
        total,
        find,
        refetch,
    };
};
